<template>
  <div class="inplay-event">
    <div class="title-wr p-n">
      <div class="title text-ellipsies">{{ event.inPlayMatchName }}</div>
      <div class="sport-icon" v-html="sport?.svg"></div>
    </div>
    <div class="p-n">
      <div class="market-name">{{ market?.elRespose }}</div>
      <div 
        v-for="(ev) in market.events.filter(ev => ev?.price)?.slice(0, maxEventsToDisplay)" 
        :key="ev.eventId"
        class="result-line"
      >
        <div class="result-main">{{ ev.selName }}</div>
        <div class="result-odd">
          <odd-btn 
            :race="ev"
            :selection="parseInt(ev.selection)"
            :showEmptyButton="false"
            :showAddInfo="false"
            class="slider-odd"
          />
        </div>
      </div>
      <div 
        v-if="market.events.filter(ev => ev?.price)?.length > maxEventsToDisplay"
        class="result-line"
      >...</div>
    </div>
    <div class="bottom-content-wr">
      <div class="p-n">
        <router-link 
          class="geoff-link-accent" 
          :to="{name:'inplay'}"
        >View All</router-link>
      </div>
    </div>
  </div>
</template>

<script>

  import OddBtn from "@/components/UI/OddBtn";

  export default {
    name: "InplaySliderItem",
    components: { 
      OddBtn
    },
    props: {
      event: {
        type: Object,
      },
      maxEventsToDisplay: {
        type: Number,
        default: 4
      }
    },
    data: ()=>{
      return {}
    },
    computed: {
      sport() {
        return this.API.SPORTS.find(sport => sport?.code === this.event.sportcode || sport?.antePostCode === this.event.sportcode)
      },
      market() {
        return this.event?.fullcard?.find(x=>x!==undefined)
      }
    },
    methods:{},
  }
</script>

<style scoped lang="scss">
  .inplay-event {
    width: 100%;
    height: 100%;

    .title-wr {
      border-bottom: 1px solid var(--geoff-menu-item-separator);
      display: flex;
      justify-content: space-between;
      gap: 0.75rem;
      align-items: center;
      height: 2.375rem;

      .title {
        font-size: 0.8125rem;
        font-weight: 600;
      }
    }

    .sport-icon {
      width: 1.375rem;
      height: 1.375rem;
      display: flex;
    }

    .market-name {
      color: var(--geoff-item-timestamp);
      font-size: 0.75rem;
      text-align: center;
    }

    .result-line {
      display: flex;
      font-size: 0.875rem;
      margin-bottom: 0.5rem;
      justify-content: space-between;
      gap: 1rem;

      &:last-child {
        margin-bottom: 0;
      }

      .result-main {
        display: flex;
        flex-grow: 1;
        align-items: center;
      }

      .result-odd {
        min-width: 3rem;
        font-weight: 600;
        white-space: nowrap;
      }
    }

    .bottom-content-wr {
      font-size: 0.825rem;
      border-top: 1px solid var(--geoff-menu-item-separator);
      text-align: center;

      .geoff-link-accent {
        text-decoration: none;
        text-transform: uppercase;
      }
    }
  }
</style>